import { Home, Calculator, FileText, Search, Key, Bus, ArrowRight } from "lucide-react";

export const vendorType = [
  "Mortgage Broker",
  "Conveyancer/Solicitor",
  "Building & Pest inspector",
  "Buyers agent",
  "Property Manager",
  "Realestate Agent",
  "Accountant",
  "Building Surveyor"
  ];

  export const vendorIcons = {
    "Realestate Agent": Home,
    "Conveyancer/Solicitor": FileText,
    "Building & Pest inspector": Search,
    "Buyers agent": Bus,
    "Property Manager": Key,
    "Mortgage Broker": Calculator,
    "Accountant": Calculator,
    "Building Surveyor": Search,
  };

  export const vendorDescriptions = {
    "Realestate Agent": "Expert guidance through property selection and negotiation",
    "Conveyancer/Solicitor": "Handle legal aspects of property transactions",
    "Building & Pest inspector": "Thorough property condition assessments",
    "Buyers agent": "Specialized guidance for first-time buyers and investors",
    "Property Manager": "Professional property management services",
    "Mortgage Broker": "Secure the best financing options for your purchase",
    "Accountant": "Trusted financial advice and tax planning for property investments",
    "Building Surveyor": "Ensure compliance with building codes and safety standards",
  };  